import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FavsCtx } from '../App.jsx';
import { MOCK_PROPERTIES } from '../api/mock.js';
import { adapt } from '../api/client.js';
import PropertyCard from '../components/property/PropertyCard.jsx';

export default function Favorites() {
  const { favs } = useContext(FavsCtx);
  const list = MOCK_PROPERTIES.map(adapt).filter(p => favs.includes(p.id));
  return (
    <div className="container page">
      <div className="page-head">
        <span className="kicker">Tu selección</span>
        <h1 className="page-h1">Favoritos</h1>
        <p className="page-sub">Las propiedades que guardaste se quedan acá, incluso si cerrás el navegador.</p>
      </div>
      {list.length === 0
        ? <div className="empty"><div className="empty-ic">♥</div><h3>Todavía no guardaste ninguna propiedad</h3><p>Tocá el corazón en cualquier propiedad para guardarla.</p><Link className="btn btn-primary" to="/buscar?op=venta">🔍 Explorar propiedades</Link></div>
        : <div className="feat-grid">{list.map(p => <PropertyCard key={p.id} p={p} />)}</div>}
    </div>
  );
}
